import './OHIFLogo.css';
import LogoLarge from '../../imgs/logo/logo-large.png';
import logo_en from '../../imgs/logo/logo_en.png';
import logo_cn from '../../imgs/logo/logo_cn.png';
import { Translation } from 'react-i18next';

import React from 'react';

function OHIFLogo() {
  return (
    <div className="header-brand">
      <div className="header-logo-image">
        <img src={logo_cn} alt="" />
      </div>
    </div>
  );
}

function OHIFLogoEn() {
  return (
    <div className="header-brand">
      <div className="header-logo-image">
        <img src={logo_en} alt="" />
      </div>
    </div>
  );
}

function OHIFLoginLogo() {
  return (
    <Translation>
      {t => (
        <div className="header-login">
          <div className="header-login-image">
            <img src={LogoLarge} alt="" />
          </div>
          <div className="header-login-text">{t('title')}</div>
        </div>
      )}
    </Translation>
  );
}

export { OHIFLogo, OHIFLoginLogo, OHIFLogoEn };
